export enum ActionTypes {
    FETCH_SHORT_STATISTICS = 'statistics-module/fetch-short-statistics'
}
